import { Tooltip } from '@/ui/Tooltip'
import { AllocationDetails } from '../tooltip/AllocationDetails'
import { DraggableBonnet } from '../dnd/DraggableBonnet'
import { Allocation, AllocationChange } from '@/types/vehicleAllocation'
import { SuggestionInputTable } from '@/ui/SuggestionInputTable'
import { useState } from 'react'
import styles from '../VehicleAllocationColumn.module.scss'
import { useDebounce } from '@/helpers/useDebounce'
import {
    useChangeRunModal,
    useGetFleets,
    useValidateFleetNumber,
    useVehicleAllocationStore,
} from '@/pages/VehicleAllocationController'
import { useClickOutside } from '@/helpers/useClickOutside'

interface AllocationBonnetProps {
    allocation: Allocation
    allAllocations: Allocation[]
    allocationChange?: AllocationChange
    route: string
}

export const AllocationBonnet = ({ allocation, allAllocations, allocationChange, route }: AllocationBonnetProps) => {
    const { allocationChanges, setAllocationChanges, routeEditing } = useVehicleAllocationStore()
    const [isManualEdit, setIsManualEdit] = useState(false)
    const { data: fleets } = useGetFleets()
    const debouncedFleetNumber = useDebounce(allocationChange?.fleetNumber, 300)

    useValidateFleetNumber(allocation, allocationChange, debouncedFleetNumber)
    useChangeRunModal(allAllocations, isManualEdit, allocation, allocationChange)

    const handleChangeInput = (value: string) => {
        // check if allocation was previously changed
        const filteredAllocationChanges = allocationChanges.filter((change) => change.run !== allocation.run)

        setAllocationChanges([
            ...filteredAllocationChanges,
            {
                run: allocation.run,
                fleetNumber: value,
            },
        ])
    }

    const wrapperRef = useClickOutside<HTMLDivElement>(() => setIsManualEdit(false), true)

    if (isManualEdit && routeEditing === route) {
        return (
            <div ref={wrapperRef}>
                <SuggestionInputTable
                    autoFocus
                    options={
                        fleets?.map((fleet) => ({
                            id: fleet.fleetNumber,
                            label: fleet.fleetNumber ?? '',
                            value: fleet.fleetNumber,
                        })) ?? []
                    }
                    value={allocationChange ? (allocationChange.fleetNumber ?? '') : (allocation.bonnet ?? '')}
                    onChange={handleChangeInput}
                    transparent
                    inputClassName={styles.input}
                    className={styles.dropdown}
                    displayValueInsteadOfLabel
                    type="text"
                    maxLength={7}
                />
            </div>
        )
    }

    return (
        <Tooltip
            isShown={routeEditing !== route}
            tooltip={<AllocationDetails allocation={allocation} />}
            trigger="hover"
            placement="top"
        >
            <DraggableBonnet
                allocation={allocation}
                allocationChange={allocationChange}
                setIsManualEdit={setIsManualEdit}
                route={route}
            />
        </Tooltip>
    )
}
